import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

import Navigation from '@homeaway/react-navigation';
import {CALENDAR__24} from '@homeaway/svg-defs/lib/defs/CALENDAR__24';
import {MESSAGE__24} from '@homeaway/svg-defs/lib/defs/MESSAGE__24';
import {CHEVRON_LEFT__16} from '@homeaway/svg-defs/lib/defs/CHEVRON_LEFT__16';
import {CREDIT_CARD__24} from '@homeaway/svg-defs/lib/defs/CREDIT_CARD__24';
import {SVGIcon} from '@homeaway/react-svg';
import {ARROW_LEFT__24} from '../../atoms/baseline/baseline';

import {ACTION_LOCATION_NAMES} from '../constants';
import {UTM_MEDIUM, UTM_MEDIUM_EMAIL} from '../../constants';

import {StayConsumer} from '../../context/StayContext';
import translate from '../../../utils/translations';
import {
    tripPaymentSetSelected,
    tripMessageSetSelected,
} from '../../../utils/EDAP/Conversation';

import './ConversationNavbar.less';

import {Link as LocalisedLink} from '@homeaway/react-localization-components';
import {withRouter} from 'react-router';
import URLSearchParams from '@ungap/url-search-params';

class ConversationNavbar extends Component {
    static propTypes = {
        activeTab: PropTypes.number,
        backUrl: PropTypes.string,
        conversationId: PropTypes.string,
        isHybridInbox: PropTypes.bool,
        stayLocation: PropTypes.string,
        systemData: PropTypes.shape({}),
        tabs: PropTypes.arrayOf(PropTypes.string),
        translations: PropTypes.shape({}),
    };

    static defaultProps = {
        activeTab: 1,
        backUrl: '/traveler/th/inbox',
        tabs: ['back', 'details'],
        systemData: {},
        translations: {},
    };

    handleBack = () => {
        const {history, backUrl} = this.props;
        const {search} = history.location;
        const params = new URLSearchParams(search);
        const queryParamlooked = params.get(UTM_MEDIUM);
        if (queryParamlooked === UTM_MEDIUM_EMAIL) {
            window.location.href = backUrl;
        } else {
            history.goBack();
        }
    };

    handleNavigationClick = (
        newIndex,
        reservationArrival,
        reservationDeparture,
        reservationUuid
    ) => {
        const {activeTab, tabs} = this.props;
        if (newIndex !== activeTab) {
            const actionLocation = ACTION_LOCATION_NAMES[tabs[activeTab]];

            if (tabs[newIndex] === 'messages') {
                tripMessageSetSelected({
                    actionLocation,
                    reservationArrival,
                    reservationDeparture,
                    reservationUuid,
                });
            } else if (tabs[newIndex] === 'payments') {
                tripPaymentSetSelected({
                    actionLocation,
                    reservationArrival,
                    reservationDeparture,
                    reservationUuid,
                });
            }
        }
    };

    get links() {
        const {backUrl, conversationId, isHybridInbox, tabs, translations} =
            this.props;
        let links = [
            {
                href: this.props.backUrl,
                label: translate(
                    translations,
                    'trav-dash/trav-home',
                    'messages',
                    'th.inbox.conversation.buttons.back'
                ),
                node: (
                    <>
                        {!isHybridInbox && (
                            <Link
                                className="hidden-xs Navigation__a"
                                to={backUrl}
                            >
                                <span>
                                    <SVGIcon
                                        inlineFlex
                                        markup={CHEVRON_LEFT__16}
                                    />
                                    <span>
                                        {translate(
                                            translations,
                                            'trav-dash/trav-home',
                                            'messages',
                                            'th.inbox.conversation.buttons.back'
                                        )}
                                    </span>
                                </span>
                            </Link>
                        )}

                        {isHybridInbox && (
                            <LocalisedLink onClick={this.handleBack}>
                                <span>
                                    <SVGIcon
                                        inlineFlex
                                        markup={ARROW_LEFT__24}
                                    />
                                </span>
                            </LocalisedLink>
                        )}
                    </>
                ),
            },
        ];

        if (tabs.indexOf('details') !== -1 && !isHybridInbox) {
            links.push({
                href: `/traveler/th/inbox/conversation/${conversationId}/details`,
                label: translate(
                    translations,
                    'trav-dash/trav-home',
                    'messages',
                    'th.inbox.conversation.buttons.details'
                ),
                node: (
                    <Link
                        to={{
                            pathname: `/traveler/th/inbox/conversation/${conversationId}/details`,
                            state: {
                                backUrl,
                                tabChange: true,
                            },
                        }}
                    >
                        <SVGIcon className="visible-xs" markup={CALENDAR__24} />
                        <span className="hidden-xs">
                            {translate(
                                translations,
                                'trav-dash/trav-home',
                                'messages',
                                'th.inbox.conversation.buttons.details'
                            )}
                        </span>
                    </Link>
                ),
            });
        }

        if (tabs.indexOf('messages') !== -1) {
            links.push({
                href: `/traveler/th/inbox/conversation/${conversationId}/messages`,
                label: translate(
                    translations,
                    'trav-dash/trav-home',
                    'messages',
                    'th.inbox.conversation.buttons.messages'
                ),
                node: (
                    <>
                        {!isHybridInbox && (
                            <Link
                                to={{
                                    pathname: `/traveler/th/inbox/conversation/${conversationId}/messages`,
                                    state: {
                                        backUrl,
                                        tabChange: true,
                                    },
                                }}
                                className={'Navigation__a'}
                            >
                                <SVGIcon
                                    className="visible-xs"
                                    markup={MESSAGE__24}
                                />

                                <span className="hidden-xs">
                                    {translate(
                                        translations,
                                        'trav-dash/trav-home',
                                        'messages',
                                        'th.inbox.conversation.buttons.messages'
                                    )}
                                </span>
                            </Link>
                        )}
                    </>
                ),
            });
        }

        if (tabs.indexOf('payments') !== -1 && !isHybridInbox) {
            links.push({
                href: `/traveler/th/inbox/conversation/${conversationId}/payments`,
                label: translate(
                    translations,
                    'trav-dash/trav-home',
                    'messages',
                    'th.inbox.conversation.buttons.payments'
                ),
                node: (
                    <Link
                        to={{
                            pathname: `/traveler/th/inbox/conversation/${conversationId}/payments`,
                            state: {
                                backUrl,
                                tabChange: true,
                            },
                        }}
                    >
                        <SVGIcon
                            className="visible-xs"
                            markup={CREDIT_CARD__24}
                        />
                        <span className="hidden-xs">
                            {translate(
                                translations,
                                'trav-dash/trav-home',
                                'messages',
                                'th.inbox.conversation.buttons.payments'
                            )}
                        </span>
                    </Link>
                ),
            });
        }

        return links;
    }

    render() {
        const {backUrl, isHybridInbox, stayLocation} = this.props;
        return (
            <nav className="ConversationNavbar Conversation__ShowBorderBottom">
                <div className="container">
                    <div className="ConversationNavbar__inner hidden-lg hidden-md hidden-sm">
                        {isHybridInbox ? (
                            <LocalisedLink
                                className="ConversationNavbar__back"
                                onClick={this.handleBack}
                            >
                                <SVGIcon markup={CHEVRON_LEFT__16} />
                            </LocalisedLink>
                        ) : (
                            <Link
                                className="ConversationNavbar_back"
                                to={backUrl}
                            >
                                <SVGIcon markup={CHEVRON_LEFT__16} />
                            </Link>
                        )}

                        <h3 className="ConversationNavbar__header">
                            {stayLocation}
                        </h3>
                    </div>

                    <StayConsumer>
                        {({stay}) => {
                            const {
                                booking: {arrival, departure, reservationUuid},
                            } = stay;
                            return (
                                <Navigation
                                    activeIndex={this.props.activeTab}
                                    className={`ConversationNavbar__nav ${
                                        isHybridInbox ? 'hidden-xs' : ''
                                    }`}
                                    leftAlign
                                    links={this.links}
                                    noMobileSelect
                                    onLinkClick={(_, newIndex) =>
                                        this.handleNavigationClick(
                                            newIndex,
                                            arrival,
                                            departure,
                                            reservationUuid
                                        )
                                    }
                                />
                            );
                        }}
                    </StayConsumer>
                </div>
            </nav>
        );
    }
}

const ConversationNavbarWithRouter = withRouter(ConversationNavbar);
export default ConversationNavbarWithRouter;
